export default __webpack_public_path__ + "static/media/GR00001-logo.b7666ee3.svg";